<template>
  <div class="detail-buy-button" ref="detailBuyButton">
    <div v-if="dataLoading" class="btn-loading">
      <spinner-loading class="spinner-loading" />
    </div>
    <div v-else>
      <div class="btn">
        <div
          class="btn__add-car"
          @click="handleAddCart($event)"
          v-if="Number(courseDetail.cartModule.isShowCartButton) === 1"
        >
          <div class="btn__add-car__text">
            <div
              class="btn__add-car__content"
              :style="{
                fontSize: courseDetail.cartModule.cartButtonPromotionText ? '14px' : '18px'
              }"
            >
              加入购物车
            </div>
            <div class="btn__add-car__tips" v-if="courseDetail.cartModule.cartButtonPromotionText">
              <p class="btn__add-car__tips__linel"></p>
              <p class="btn__add-car__tips__text">
                {{ courseDetail.cartModule.cartButtonPromotionText }}
              </p>
              <p class="btn__add-car__tips__liner"></p>
            </div>
          </div>
          <div class="btn__add-car__ball" ref="cartBall">购</div>
        </div>
        <div
          class="btn__immediately"
          :class="{
            btn__immediately__disable: isDisabled,
            btn__immediately__onlyOne: Number(courseDetail.cartModule.showCartButton) !== 1
          }"
          @click="handleBuyBtn($event)"
        >
          {{ courseDetail.buttonModule.desc }}
        </div>
      </div>
      <!-- 联报按钮 -->
      <div
        class="btn__union"
        v-if="courseDetail.unionInfoModule && JSON.stringify(courseDetail.unionInfoModule) !== '{}'"
        @click="handleUnionBtn($event)"
      >
        <div class="title">{{ courseDetail.unionInfoModule.title }}<span v-if="courseDetail.unionInfoModule.labelText" class="discount">{{ courseDetail.unionInfoModule.labelText }}</span></div>
        <div class="sub-title">{{ courseDetail.unionInfoModule.subTitle }}</div>
      </div>
    </div>
    <!-- 续报购买弹框 -->
    <buy-dialog
      v-if="showBuyDialog"
      @closeDialog="handleCloseDialog"
      :isAddCartDialog="isAddCartDialog"
      @openShoppingDailog="handleShoppingDailog"
      @openShoppingToast="handleShoppingToast"
    />
    <!-- 购物车弹窗 -->
    <div v-if="openShoppingDialog">
      <div class="dialog__background"></div>
      <div class="alert__dialog">
        <div class="dialog__close" @click="handleCloseCart"></div>
        <div class="dialog__title">{{ addCartResult.title }}</div>
        <div class="dialog__content__container" v-if="addCartResult.content">
          <div class="dialog__content">{{ addCartResult.content }}</div>
        </div>
        <div class="dialog__button">
          <div class="dialog__cancle" @click="handleCloseCart">取消</div>
          <div class="dialog__handle" @click="handleShoppingCart($event)">
            {{ Number(addCartResult.type) === 1 ? '查看购物车' : '查看课程' }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="openShoppingToast" class="alert__dialog__toast">
      {{ addCartResult.title }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import types from '@/views/NewCourseDetail/store/types'
// import methods from '@/views/CourseDetail/mixins/methods'
import SpinnerLoading from '@/components/SpinnerLoading'
import BuyDialog from './BuyDialog'
import { buyStatus } from '@/defines'
// import funParabola, { initAni } from '@/util/parabola.js'
import ballAnimation from '@/util/ballAnimation'
import builder from '@/modules/dialog-builder'
import { login, getLoginURL } from '@/util/user'
import XubaoDialog from '@/views/CourseDetail/components/XubaoDialog'
import DetailAlertDailog from '@/views/CourseDetail/components/DetailAlertDailog'

// import animate from 'animate.css'
export default {
  props: {
    courseDetail: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [ballAnimation],
  data() {
    return {
      state: 1,
      showBuyDialog: false,
      openShoppingDialog: false,
      openShoppingToast: false,
      isAddCartDialog: false, // 是否展示加车按钮
      showDifficultGuide: true,
    }
  },
  components: {
    SpinnerLoading,
    BuyDialog,
  },
  mounted() {
    this.diagnoseBtnShowLog() // 诊断报名按钮的展现日志
    this.unionBtnShowLog() // 联报按钮的展现日志
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin,
      addCartResult: state => state.NewCourseDetail.addCartResult,
      dataLoading: state => state.NewCourseDetail.dataLoading,
      presaleStatus: state => state.NewCourseDetail.presaleStatus,
    }),
    // 按钮不是立即购买、诊断后报名、无资格报名、付定金、提前诊断的置灰
    isDisabled() {
      return !(
        this.courseDetail.buttonModule.id === buyStatus.immediatelyBuy ||
        this.courseDetail.buttonModule.id === buyStatus.diagnose ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.payDeposit ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.earlyDiagnose ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.diagnoseReport
      )
    },
  },
  methods: {
    ...mapMutations({
      setCartCount: types.SET_CART_COUNT
    }),
    ...mapActions({
      getAddCart: types.GET_NEW_ADD_CART,
      getPreSaleStatus: types.GET_NEW_PRESALE_STATUS,
    }),
    diagnoseBtnShowLog() {
      if (
        this.courseDetail.buttonModule.id === buyStatus.earlyDiagnose ||
        this.courseDetail.buttonModule.id === buyStatus.diagnose
      ) {
        const params = {
          show: 'diagnose-ben-show'
        }
        this.xesLog('exposure', params, this.$refs.detailBuyButton)
      }
    },
    unionBtnShowLog() {
      if (this.courseDetail.unionInfo && JSON.stringify(this.courseDetail.unionInfo) !== '{}') {
        const params = {
          key: 'union-btn-show',
        }
        this.xesLog('exposure', params, this.$route )
      }
    },
    handleCloseCart() {
      this.openShoppingDialog = false
    },
    handleShoppingCart() {
      if (Number(this.addCartResult.type) === 1) {
        window.location.href = 'https://trade.xueersi.com/shopCartWeb/#/cart'
      } else {
        window.location.href = '//i.xueersi.com/study/MyCourses/index#/'
      }
    },
    async handleBuyBtn(event) {
      if (this.isDisabled) return
      if (!this.userIsLogin) {
        const clickurl = getLoginURL()
        this.clickBuyButtonLog(clickurl, event)
        login()
        return
      }
      const { courseInfoModule: { courseId }, classLeftNumModule: { classId, checkType }, buttonModule } = this.courseDetail

      // todo 这里临时判断考试页跳转，下有同样逻辑代码兜底
      if (
          (buttonModule.id === buyStatus.earlyDiagnose ||
              buttonModule.id === buyStatus.diagnose ||
          buttonModule?.id === buyStatus.diagnoseReport ||
          buttonModule?.id === buyStatus.disqualification6) &&
          this.courseDetail.examModule.examPath
      ) {
        // 考试页
        this.clickBuyButtonLog(this.courseDetail.examModule.examPath, event)
        window.location.href = this.courseDetail.examModule.examPath
        return
      }
        // 非联报课
        const params = {
          classId: classId,
          courseId: courseId,
          checkType: checkType,
          xeswx_sourceid: this.$route.query.xeswx_sourceid,
          xeswx_sourceurl: window.location.href
        }
        await this.getPreSaleStatus(params)
        if (this.presaleStatus.status === 9) {
          login()
        } else {
          if (this.presaleStatus.status === 1 || this.presaleStatus.status === 11) {
            if (this.presaleStatus.url) {
              window.location.href = this.presaleStatus.url
              this.$xesLogger.clickMsg({ params: {
                  type: `xeslog-courseDetail-payPresale`,
                  clickId: '1.3.38',
                  clickUrl: this.presaleStatus.url
                }})
              return
            }
          } else {
            const detailAlertDailog = builder(DetailAlertDailog, this.$router, this.$store)
            const dialogData = {
              ...this.presaleStatus,
              // idEncode: this.courseDetail.idEncode
            }
            await detailAlertDailog({ presaleStatus: dialogData })
          }
        }
      // 续报弹框
      if (this.courseDetail.dialogModule && this.courseDetail.dialogModule.type) {
        this.clickBuyButtonLog('xubaotankuang', event)
        const xubaoDialog = builder(XubaoDialog, this.$router, this.$store)
        const buyThisCourse = await xubaoDialog({ data: this.courseDetail.dialogModule })
        if (!buyThisCourse) return
      }
      if (
        (buttonModule.id === buyStatus.earlyDiagnose ||
          buttonModule.id === buyStatus.diagnose) &&
        this.courseDetail.examModule.examPath
      ) {
        // 考试页
        this.clickBuyButtonLog(this.courseDetail.examModule.examPath, event)
        window.location.href = this.courseDetail.examModule.examPath
        return
      }
      // 查看诊断报告
      if (
        buttonModule.id === buyStatus.diagnoseReport &&
        this.courseDetail.examModule.examPath
      ) {
        this.$xesLogger.clickMsg({ params: { type: 'xeslog-scanReport', clickId: '1.3.36', courseid: this.courseDetail.id }})
        window.open(this.courseDetail.examPath)
      }
      if (buttonModule.id === buyStatus.immediatelyBuy) {
        // 报名链接
        this.clickBuyButtonLog(
          buttonModule.url,
          event
        )
        window.location.href = buttonModule.url
      }
    },
    handleUnionBtn() {
      if (!this.userIsLogin) {
        login()
        return
      }
      this.$xesLogger.clickMsg({params: { key: 'union-btn-click', clickUrl: this.courseDetail.unionInfoModule.url }})
      window.location.href = this.courseDetail.unionInfoModule.url
    },
    async handleAddCart(event) {
      console.log('cart userISlogin', this.userIsLogin)
      if (!this.userIsLogin) {
        login()
        return
      }
      this.handleAddCartLog(event)
      const { courseInfoModule: { courseId }, classLeftNumModule: { classId }, logModule: { promotionId, promotionType }} = this.courseDetail

      const params = [
        {
          productId: courseId,
          classId: classId,
          parentProductId: 0,
          promotionId: promotionId ||  0,
          promotionType: promotionType || 0
        }
      ]
      await this.getAddCart(params)
      if (Number(this.addCartResult.status) !== 0) {
        if (Number(this.addCartResult.type) === 3) {
          this.openShoppingToast = true
          setTimeout(() => {
            this.openShoppingToast = false
          }, 1500)
        } else {
          this.openShoppingDialog = true
        }
      } else {
        this.addCartAni('cartBall')
      }
    },
    handleCancleBuy() {
      this.handleClose()
      // this.cancleBuy = 1
    },
    handleCloseDialog() {
      this.showBuyDialog = false
      this.isAddCartDialog = false
    },
    handleShoppingDailog() {
      this.openShoppingDialog = true
    },
    handleShoppingToast() {
      this.openShoppingToast = true
      setTimeout(() => {
        this.openShoppingToast = false
      }, 1500)
    },
    handleAddCartLog(event) {
      const params = {
        key: `xeslog-clickaddshoppingcartbut-courseDetail`,
        clickId: '1.8.5',
        counselorid: this.courseDetail.classLeftNumModule.classId || '',
        exclusiveid: this.courseDetail.classLeftNumModule.classId || '',
        timeid: this.courseDetail.courseInfoModule.schoolTimeName,
        difficultid: this.courseDetail.courseInfoModule.difficulty.alias,
        coursetype: this.courseDetail.courseInfoModule.courseType
      }
      // this.xesLog('click', params, event)
      this.$xesLogger.clickMsg({ params: { params }})
    },
    clickBuyButtonLog(clickurl, event) {
      let params = {
        key: 'xeslog-buyButton-courseDetail',
        action: 'click-immediately-apply-btn',
        clickid: '1.3.2',
        clickurl
      }
      if (
        this.courseDetail.buttonModule.id === buyStatus.earlyDiagnose ||
        this.courseDetail.buttonModule.id === buyStatus.diagnose
      ) {
        params.clickid = 'diagnose'
      }
      this.$xesLogger.clickMsg({ params })
    },
    buyStatusLog(status, event) {
      let params = {}
      switch (status) {
        case 4:
          params = {
            type: `xeslog-courseDetail-alreadyBuy`,
            clickId: '1.3.39'
          }
          break
        case 2:
          params = {
            type: `xeslog-courseDetail-alreadyOrder`,
            clickId: '1.3.40'
          }
          break
        case 3:
          params = {
            type: `xeslog-courseDetail-payFinal`,
            clickId: '1.3.44'
          }
          break
        case 5:
          params = {
            type: `xeslog-courseDetail-continuedBuy`,
            clickId: '1.3.45'
          }
          break
        default:
          return false
      }
      // this.xesLog('click', params, event)
      this.$xesLogger.clickMsg({params: { params }})
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(detail-buy-button) {
  margin-top: 36px;
}
.btn__union {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 12px;
  width: 320px;
  height: 48px;
  background-image: url('../images/union_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  cursor: pointer;
  .title {
    line-height: 18px;
    font-size: 18px;
    color: #994F0B;
    font-weight: 600;
    position: relative;
    .discount {
      position: absolute;
      top: -2px;
      white-space: nowrap;
      display: inline-block;
      font-size: 11px;
      color: #ffffff;
      background: linear-gradient(139deg, #FF3C3C 0%, #F13232 100%);
      padding: 0 4px;
      border-radius: 2px;
      margin-left: 8px;
      &::before{
        display: inline-block;
        content: '';
        width: 0;
        height: 0;
        border: 4px solid;
        border-color: transparent transparent #FF3C3C;
        position: absolute;
        bottom: 0;
        left: -4px;
      }
    }
  }
  .sub-title {
    margin-top: 4px;
    font-size: 12px;
    color: #994F0B;
    line-height: 12px;
    position: relative;
    &::before {
      display: inline-block;
      content: '';
      width: 65px;
      height: 1px;
      background-image: url('../images/line.png');
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      left: -72px;
      top: 50%;
      transform: translateY(-50%);
    }
    &::after {
      display: inline-block;
      content: '';
      width: 65px;
      height: 1px;
      background-image: url('../images/line.png');
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      right: -72px;
      top: 50%;
      transform: translateY(-50%) rotateY(180deg);
    }
  }
}
@include b(btn) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @include e(immediately) {
    width: 150px;
    height: 40px;
    background: rgba(241, 50, 50, 1);
    border-radius: 2px;
    color: #ffffff;
    font-size: 18px;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
    &:hover {
      background: rgba(250, 71, 71, 1);
    }
    &:active {
      background: rgba(212, 37, 37, 1);
    }
    @include e(disable) {
      background: #c1c1c1 !important;
      cursor: not-allowed !important;
    }
    @include e(onlyOne) {
      width: 280px;
      margin-left: 20px;
    }
  }
  @include e(add-car) {
    position: relative;
    width: 150px;
    height: 40px;
    @include e(tips) {
      display: flex;
      justify-items: center;
      justify-content: center;
      height: 14px;
      @include e(linel) {
        width: 12px;
        height: 1px;
        margin: 6.5px 4px 6.5px 0;
        background: linear-gradient(
          90deg,
          rgba(253, 234, 234, 1) 0%,
          rgba(255, 169, 128, 1) 30%,
          rgba(240, 119, 60, 1) 100%
        );
      }
      @include e(liner) {
        width: 12px;
        height: 1px;
        margin: 6.5px 0 6.5px 4px;
        background: linear-gradient(
          270deg,
          rgba(253, 234, 234, 1) 0%,
          rgba(255, 169, 128, 1) 30%,
          rgba(240, 119, 60, 1) 100%
        );
      }
      @include e(text) {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(240, 119, 60, 1);
      }
    }
    @include e(content) {
      color: rgba(241, 50, 50, 1);
      font-size: 14px;
      line-height: 18px;
    }
    @include e(text) {
      display: flex;
      justify-content: center;
      flex-direction: column;
      box-sizing: border-box;
      text-align: center;
      width: 150px;
      height: 40px;
      background: rgba(241, 50, 50, 0.1);
      border: 1px solid rgba(241, 50, 50, 1);
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        border: 1px solid #f35b5b;
      }
      &:active {
        border: 1px solid #c02828;
      }
    }
    @include e(ball) {
      visibility: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 16px;
      width: 16px;
      font-size: 12px;
      border-radius: 50%;
      background-color: rgba(241, 50, 50, 0.1);
      color: #f13232;
      z-index: 9999;
    }
  }
}
.dialog__background {
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  position: fixed;
  background: #000000;
  top: 0;
  left: 0;
  z-index: 2000;
}
.alert__dialog {
  width: 446px;
  // height: 234px;
  background: #ffffff;
  border-radius: 2px;
  top: 45%;
  left: 40%;
  line-height: 25px;
  position: fixed;
  z-index: 2001;
  .dialog__close {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 20px;
    right: 20px;
    background-image: url('~@/views/CourseDetail/images/close-btn-gray.png');
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .dialog__title {
    font-weight: 600;
    margin-top: 66px;
    text-align: center;
    color: #333333;
    font-size: 16px;
  }
  .dialog__content__container {
    text-align: center;
    .dialog__content {
      text-align: left;
      display: inline-block;
      margin-top: 20px;
      color: #666666;
      font-size: 14px;
      line-height: 22px;
      padding: 0 30px 0 30px;
    }
  }
  .dialog__button {
    margin-left: 81px;
    font-size: 14px;
    margin-top: 56px;
    margin-bottom: 32px;
    & > div {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
    }
    .dialog__cancle {
      display: inline-block;
      border: 1px #dedede solid;
      border-radius: 2px;
      cursor: pointer;
    }
    .dialog__handle {
      margin-left: 24px;
      display: inline-block;
      color: #ffffff;
      background: #f13232;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.alert__dialog__toast {
  position: fixed;
  z-index: 2000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(17, 17, 17, 0.7);
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  padding: 0 15px;
}
.btn-loading {
  position: relative;
  height: 40px;
  width: 280px;
  background: #f13232;
  border-radius: 2px;
  color: #ffffff;
  margin: 0 20px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
}
.spinner-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5, 0.5);
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DetailBuyButton.vue